import React, { useEffect } from 'react';
import { func, number } from 'prop-types';

import { MediaPermissions } from '../constants';

import NoPermission from './NoPermission';
import SystemPermission from './SystemPermission';

function ModalDeniedPermisson({ cameraPermission, micPermission, onClose }) {
  if (
    cameraPermission === MediaPermissions.UserPermissionDenied ||
    micPermission === MediaPermissions.UserPermissionDenied
  ) {
    return (
      <NoPermission
        cameraPermission={cameraPermission}
        micPermission={micPermission}
        onClose={onClose}
      />
    );
  }
  if (
    cameraPermission === MediaPermissions.SystemPermissionDenied ||
    micPermission === MediaPermissions.SystemPermissionDenied
  ) {
    return (
      <SystemPermission
        onClose={onClose}
        cameraPermission={cameraPermission}
        micPermission={micPermission}
      />
    );
  }

  return null;
}

ModalDeniedPermisson.propTypes = {
  cameraPermission: number,
  micPermission: number,
  onClose: func.isRequired,
};

ModalDeniedPermisson.defaultProps = {
  cameraPermission: null,
  micPermission: null,
};

export default ModalDeniedPermisson;
